import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { getSessionValue, setSessionValue, setSessionValues } from './storage';
var GEO_SESSION_KEY = 'geo';
var EXCLUDE_PATHS = ['/public'];
var GEO_IS_ANSWERED_KEY = 'geo_is_answered';
export var getGeo = function getGeo() {
  return getSessionValue(GEO_SESSION_KEY);
};

var getIsAnswered = function getIsAnswered() {
  return getSessionValue(GEO_IS_ANSWERED_KEY);
};

var setGeo = function setGeo(_ref) {
  var _setSessionValues;

  var latitude = _ref.latitude,
      longitude = _ref.longitude;
  setSessionValues((_setSessionValues = {}, _defineProperty(_setSessionValues, GEO_IS_ANSWERED_KEY, true), _defineProperty(_setSessionValues, GEO_SESSION_KEY, "".concat(latitude, ",").concat(longitude)), _setSessionValues));
};

var setIsAnswered = function setIsAnswered() {
  return setSessionValue(GEO_IS_ANSWERED_KEY, true);
};

var isAnswered = function isAnswered() {
  return !!getIsAnswered() || EXCLUDE_PATHS.some(function (path) {
    return window.location.href.includes(path);
  });
};

export var requestGeo = function requestGeo() {
  if (!navigator.geolocation || !navigator.geolocation.getCurrentPosition || isAnswered()) {
    return;
  }

  navigator.geolocation.getCurrentPosition(function (position) {
    setGeo(position.coords);
  }, function (error) {
    if ([error.PERMISSION_DENIED, error.POSITION_UNAVAILABLE].includes(error.code)) {
      setIsAnswered();
    }
  });
};